import { Link } from 'react-router-dom';

export default function Database() {
  return (
    <div style={{padding:"40px 32px",fontFamily:"system-ui,-apple-system,sans-serif"}}>
      <h1 style={{fontSize:28,fontWeight:700,marginBottom:8}}>🗄️ Database</h1>
      <p style={{color:"#94A3B8",marginBottom:32}}>SQL, commands, and concepts for Oracle and PostgreSQL.</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:16}}>
        <Link to="/database/db-commands" style={{background:"#1A2235",border:"1px solid #1E2D45",borderRadius:10,
          padding:"20px 22px",textDecoration:"none",display:"block"}}>
          <div style={{fontSize:24,marginBottom:8}}>📋</div>
          <div style={{fontSize:16,fontWeight:600,color:"#F0F6FF",marginBottom:4}}>DB Commands</div>
          <div style={{fontSize:13,color:"#94A3B8"}}>Oracle vs PostgreSQL — Complete command cheat sheet</div>
        </Link>
      </div>
    </div>
  );
}
